/**
 * @file: useCheckForUpdates.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { BehaviorSubject } from 'rxjs';

export const useCheckForUpdates = () => {};

export const updateCheckingLogs$ = new BehaviorSubject([]);
